import { getFeatureFlag } from './getFeatureFlag';

export const getUseFeatureFlagsMethods = ({
    data,
    overrides,
}: {
    data?: Record<string, boolean | string | null>;
    overrides?: Record<string, string>;
}) => ({
    getFeatureFlag: getFeatureFlag(data, overrides),
});
